import { RichText } from 'prismic-reactjs';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { fromTabletBreakpoint, tabletBreakpoint } from '@/src/domains/shared/breakpoints';
import { GatedContentFormWrapped } from '@/src/views/ReimagineRemote/GatedContentForm';

const SectionWrapper = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '80px', '130px')}
  background: var(--colors-zircon);
  position: relative;
`;

const MainContent = styled.div`
  margin-top: 20px;

  ${tabletBreakpoint(css`
    padding: 0 32px;
  `)}
`;

const ContentWrapper = styled(ContentContainer)`
  position: relative;
  display: grid;
  gap: 40px;

  ${MainContent} {
    grid-row: 2;
  }

  ${fromTabletBreakpoint(css`
    grid-auto-flow: column;
    grid-template-columns: 1fr clamp(400px, 35vw, 450px);

    ${MainContent} {
      grid-row: 1;
    }
  `)}
`;

export const TitleComponent = styled.div`
  ${({ theme }) => theme.typography.scale3}
  ${fluidProp('font-size', '28px', '36px')}
  color: var(--colors-darkBlue);

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const DescriptionComponent = styled.div`
  ${({ theme }) => theme.typography.bodyLead}
  ${fluidProp('line-height', '24px', '26px')}
  color: var(--colors-bayoux);
  margin-top: 20px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

const FormWrapper = styled.div`
  ${fluidProp('margin-top', '-200px', '-290px')}
  min-width: 330px;

  ${fromTabletBreakpoint(css`
    min-width: 400px;
  `)}
`;

export const SubheroWithForm = ({
  title,
  description,
  hubspotFormDefinition,
  gatedFile,
  gatedFileDownloadLabel,
  htmlSerializer,
}) => (
  <SectionWrapper>
    <ContentWrapper>
      <MainContent>
        {title && <RichText render={title} Component={TitleComponent} />}
        <RichText
          render={description}
          Component={DescriptionComponent}
          htmlSerializer={htmlSerializer}
        />
      </MainContent>
      <FormWrapper>
        <GatedContentFormWrapped
          hubspotFormDefinition={hubspotFormDefinition}
          gatedFile={gatedFile}
          gatedFileDownloadLabel={gatedFileDownloadLabel}
        />
      </FormWrapper>
    </ContentWrapper>
  </SectionWrapper>
);
